import {Banner} from '@primer/react'

import styles from './InaccessibleAttachmentsBanner.module.css'

interface InaccessibleAttachmentsBannerProps {
  inaccessibleCount: number
  onDismiss: () => void
}

export function InaccessibleAttachmentsBanner({inaccessibleCount, onDismiss}: InaccessibleAttachmentsBannerProps) {
  const message =
    inaccessibleCount === 1
      ? '1 attachment in your text may not be visible to all the viewers of the repository due to being from a repository with restricted access.'
      : `${inaccessibleCount} attachments in your text may not be visible to all the viewers of the repository due to being from a repository with restricted access.`

  return (
    <div role="status">
      {inaccessibleCount > 0 && (
        <Banner
          hideTitle
          variant="warning"
          title="Inaccessible attachments"
          description={message}
          flush
          onDismiss={onDismiss}
          className={styles.banner}
        />
      )}
    </div>
  )
}
